export default "__VITE_ASSET__Ei849fkS__"